import { render, staticRenderFns } from "./OAuthVerificationPage.vue?vue&type=template&id=00e89b96"
import script from "./OAuthVerificationPage.vue?vue&type=script&lang=js"
export * from "./OAuthVerificationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports